/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Genre_AcademicInputs */

const en_onboarding_genre_academic = /** @type {(inputs: Onboarding_Genre_AcademicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Academic`)
};

const es_onboarding_genre_academic = /** @type {(inputs: Onboarding_Genre_AcademicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Académico`)
};

/**
* | output |
* | --- |
* | "Academic" |
*
* @param {Onboarding_Genre_AcademicInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_genre_academic = /** @type {((inputs?: Onboarding_Genre_AcademicInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Genre_AcademicInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_genre_academic(inputs)
	return en_onboarding_genre_academic(inputs)
});